import { AddressModel } from "./address.model";
import { ContactModel } from "./contact.model";
import { ScheduleModel } from "./schedule.model";

export class InformationModel {
  [key: string]: any;
  description: string;
  contact: ContactModel;
  address: AddressModel;
  schedule: ScheduleModel | undefined;

  constructor(obj: any = null) {
    this.description = obj?.description
    this.contact = new ContactModel(obj?.contact)
    this.address = new AddressModel(obj?.address)
    this.schedule =obj?.schedule ? new ScheduleModel(obj?.schedule) : undefined
  }
}
